import { Button, Modal } from '@teo/components';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

const DeleteModalFollow = ({
  closeModal,
  setIsOpenDeleteModal,
  title,
  heading,
  text,
  onConfirm,
}: any) => {
  const { t } = useTranslation();

  const handleDelete = async () => {
    try {
      await Promise.resolve(onConfirm?.());
    } finally {
      setIsOpenDeleteModal(false);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [closeModal]);

  return (
    <div className="bg-white">
      <div className="fixed inset-0 z-[100] flex rounded-xl bg-white/75 px-3">
        <div className="mx-auto my-8 h-max w-full max-w-lg  rounded-xl bg-white drop-shadow-m">
          <Modal.Header onClose={closeModal}>
            <h2 className="text-sm font-semibold">{title}</h2>
          </Modal.Header>

          <Modal.Body>
            <div className="flex flex-col gap-5">
              <div>
                <h3 className="mb-3 text-lg">{heading}</h3>
                <p className="text-base text-grey-06">{text}</p>
              </div>
              <div className="flex justify-between">
                <Button
                  variant="ghost"
                  onClick={() => setIsOpenDeleteModal(false)}
                >
                  {t('button.cancel')}
                </Button>
                <Button variant="destruct" onClick={() => handleDelete()}>
                  {t('button.delete')}
                </Button>
              </div>
            </div>
          </Modal.Body>
        </div>
      </div>
    </div>
  );
};

export default DeleteModalFollow;
